// eslint-disable-next-line no-unused-vars
import { sendRequest } from "./apiServices/apiConnector";

export const service_fetchTimezone = () => {
	return sendRequest(`/timezone/`).then(response => {
		return response.json();
	});
};
